import { ApolloError, useLazyQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { useSelector } from 'react-redux';

import { selectLocaleImprovementsEnabled } from 'core/userContext';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext';

import {
  fetchTemplateSingleContentByIdQuery,
  FetchTemplateSingleContentByIdQueryResponse,
} from './useTemplateSingleContentEditById';

type Config = {
  onCompleted?: (resp: FetchTemplateSingleContentByIdQueryResponse) => void;
  onError?: (error: ApolloError) => void;
  onSuccess?: (resp: FetchTemplateSingleContentByIdQueryResponse) => void;
  templateId: number;
};

export const useFetchDefaultLocaleContent = () => {
  const isLocaleImprovementsEnabled = useSelector(selectLocaleImprovementsEnabled);
  const { allProjectLocales, templateDefaultLocale } = useLocalesQueryContext();
  const localeImprovementsDefaultLocale = templateDefaultLocale?.tag || '';
  const projectHasLocales = !!allProjectLocales?.length;
  const gqlQueryOptions = ({ templateId, ...options }: Config) => ({
    ...options,
    fetchPolicy: 'no-cache' as WatchQueryFetchPolicy,
    variables: {
      id: templateId,
      ...(isLocaleImprovementsEnabled
        ? { locale: projectHasLocales ? { name: localeImprovementsDefaultLocale } : undefined }
        : {}),
    },
  });

  const [getDefaultLocaleContent, { loading }] = useLazyQuery(fetchTemplateSingleContentByIdQuery);

  return {
    getDefaultLocaleContent: (options: Config) => getDefaultLocaleContent(gqlQueryOptions(options)),
    isLoading: loading,
  };
};
